import { useQuery } from "@tanstack/react-query";
import { getCompanyNames } from "app/api/company_api";

export const useGetCompanyList = ({
  isEnable = true,
  staleTime = 30000,
  companyName,
  select = (data) => data
}) => {
  return useQuery({
    queryKey: ["companies", companyName],
    queryFn: () => getCompanyNames(isEnable, companyName),
    enabled: isEnable,
    staleTime: staleTime,
    select: select
  });
};
